import React, {
  useState, useEffect, Dispatch, SetStateAction,
} from 'react';
import { Modal } from '@zeeve-platform/modal-component';
import TokenManager from '@zeeve-platform/login-utility';
import axios from 'axios';
import stopicon from '../../../images/Stop.png';
import sync from '../../../images/sync.png';
import chart from '../../../images/Chart.png';
import lock from '../../../images/Lock.png';
import '../../../css/custom-responsive.css';
import '../../../css/custom.css';
import infocircle from '../../../images/info-circle.png';
import deleteicon from '../../../images/Delete.png';
import cloud2 from '../../../images/cloud-2.png';
import cloud3 from '../../../images/AWS.png';
import cloud5 from '../../../images/cloud-5.png';
import cloud4 from '../../../images/cloud-4.png';
import zeeveLogo from '../../../images/logo.png';
import tencentCloud from '../../../images/tencent.svg';
import runningicon from '../../../images/notifications-green.png';
import googlecloud from '../../../images/google-cloud.png';
import pendingIcon from '../../../images/notifications-time.png';
import { RpcDetailType } from '../declaration';
import {
  deleteTheNode,
  getNodeDetailsData,
  getBlockHeightData,
} from '../../../services/apisService';
import Urls from '../../../utils/util';
import Loading from '../../../components/common/loader';
import apiBackendInstance from '../../../utils/axios';
import snippet from './snippet';

interface Props {
  cloudimage: string;
  endpoint: string;
  region: string;
  node: string | number;
  state: string;
  networkId: string | number;
  setRpcDetail: (x: RpcDetailType) => void;
  setFlag: (x: boolean) => void;
  redirectionUrl: string;
  networkPayment: boolean;
  setNodeId: (x: string) => void;
  nodeID: string;
  nodeName: string;
  setSessionsKey: React.Dispatch<React.SetStateAction<string>>;
  setCodes: Dispatch<SetStateAction<any>>;
  managedHosting: boolean;
}

interface RegionBody {
  id: string | number;
  region_name: string;
  region: string;
}

const LandingCard = ({
  cloudimage,
  region,
  node,
  state,
  endpoint,
  networkId,
  setRpcDetail,
  setFlag,
  redirectionUrl,
  networkPayment,
  setNodeId,
  nodeID,
  nodeName,
  setSessionsKey,
  setCodes,
  managedHosting,
}: Props) => {
  const [inActiveBtn, setInActiveBtn] = useState<boolean>(false);
  const [regions, setRegion] = useState([] as RegionBody[]);
  const [deleteNodeBtn, setDeleteNode] = useState<boolean>(false);
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [deleteNodeMsg, setDeleteNodeMsg] = useState<string>('');
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [analyticsUrls, setAnalyticsUrls] = useState<{dashboardName: string; dashboardURL: string}[]>([]);

  const getCloudImage = (str: string | number) => {
    if (managedHosting) {
      return zeeveLogo;
    }
    switch (str.toString().toLowerCase()) {
      case '2051b7e0-0210-47e9-870f-76162f49ebf9':
        return cloud3;
      case '6cd1b682-bfe7-414c-9e4c-8ab8f8b20ac6':
        return cloud2;
      case '8691db48-8595-4eb9-9c2a-7bab535d9475':
        return cloud5;
      case 'fa02e4b7-118d-4163-8b15-26f5d18a6820':
        return cloud4;
      case 'c4ba9fa8-8fc3-4005-a837-6fa34df26ab7':
        return googlecloud;
      case '2ca3821c-864e-4a11-8280-6326db48f28c':
        return tencentCloud;
      default:
        return cloud3;
    }
  };

  const loadRegions = () => {
    apiBackendInstance
      .get(Urls.getCloudRegion(cloudimage), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        if (response && response.data && response.data.data) {
          setRegion(response.data.data);
        }
      })
      .catch(() => {
        setRegion([]);
      });
  };
  const getRegionName = (id: string | number) => {
    for (let i = 0; i < regions.length; i += 1) {
      if (regions[i].id === id.toString()) {
        return `${regions[i].region} (${regions[i].region_name})`;
      }
    }
    return 'none';
  };

  const getNodeAnalyticsUrls = async () => {
    try {
      const token = TokenManager.getInstance().getAccessToken();
      const analyticsDashboardURLsResponse = await axios.get(`/analytics/api/dashboard-urls?nodeID=${node}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });

      if (analyticsDashboardURLsResponse && analyticsDashboardURLsResponse.data) {
        setAnalyticsUrls(analyticsDashboardURLsResponse.data);
      }
    } catch (error) {
      setAnalyticsUrls([]);
    }
  };

  useEffect(() => {
    loadRegions();
    if (state && (state.toLowerCase() !== 'requested' || state.toLowerCase() !== 'failed')) {
      getNodeAnalyticsUrls();
    }
  }, []);

  const setText = async (id: number | string, val: string) => {
    setShowLoader(true);
    const response: any = await getNodeDetailsData(
      networkId.toString(),
      id.toString(),
    );
    if (response) {
      if (response && response.success) {
        setRpcDetail(response.data);
        getBlockHeight(id.toString());
        setNodeId(id.toString());
        setFlag(true);
        setSessionsKey(response.data.sessionsKey);
        // const urlTag = document.getElementById('url-tag');
        const httpPtag = document.getElementById('http-ptag');
        const webPtag = document.getElementById('web-tag');
        const sessionsKeyTag: any = document.getElementById('key-tag');
        let actionHttpURL: URL | undefined;
        let actionWssURL: URL | undefined;
        let actionGOWssURL: URL | undefined;
        if (httpPtag && webPtag) {
          // urlTag.innerHTML = `const url = "https://${response.data.rpcUsername}:****@${val}" ;`;
          if (response.data.http) {
            httpPtag.innerHTML = `https://${response.data.rpcUsername}:****@${val}/rpc`;
          } else {
            httpPtag.innerHTML = 'HTTP is disabled';
          }
          if (response.data.ws) {
            webPtag.innerHTML = `wss://${response.data.rpcUsername}:****@${val}/ws`;
          } else {
            webPtag.innerHTML = 'WSS is disabled';
          }
        }
        if (sessionsKeyTag) {
          if (response.data.sessionsKey) {
            sessionsKeyTag.value = response.data.sessionsKey;
          } else {
            sessionsKeyTag.value = '';
          }
        }
        if (response.data.http) {
          actionHttpURL = new URL(`https://${response.data.rpcUsername}:****@${val}/rpc`);
        } else {
          actionHttpURL = undefined;
        }

        if (response.data.ws) {
          actionWssURL = new URL(`wss://${response.data.rpcUsername}:****@${val}/ws`);
          actionGOWssURL = new URL(`wss://${val}/ws`);
        } else {
          actionWssURL = undefined;
        }
        setShowLoader(false);
        if (setCodes) {
          snippet(setCodes, actionHttpURL, actionWssURL, actionGOWssURL, response.data.rpcUsername);
        }
      }
    } else {
      showRpcMessage();
      setFlag(false);
      setShowLoader(false);
    }
  };

  const getBlockHeight = async (nodeId: string) => {
    const blockHeightTag = document.getElementById('blockHeight');
    const bootsrapped = document.getElementById('bootsrapped');
    setShowLoader(true);
    const response: any = await getBlockHeightData(
      networkId.toString(),
      nodeId.toString(),
    );
    setShowLoader(false);
    if (response && response.success) {
      if (blockHeightTag) {
        blockHeightTag.innerHTML = response.data.blockHeight;
      }
      if (bootsrapped) {
        bootsrapped.innerHTML = response.data.isBootstrapped;
      }
    }
  };

  const deleteNode = async () => {
    const spinnerDiv = document.getElementById('spinnerDiv');
    setInActiveBtn(true);
    if (spinnerDiv) {
      spinnerDiv.style.display = 'block';
    }
    const response: any = await deleteTheNode(
      networkId.toString(),
      nodeID.toString(),
    );
    if (response) {
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      setDeleteNode(false);
      if (response.success) {
        setDeleteNodeMsg(response.data.message);

        setInActiveBtn(false);
        setTimeout(() => {
          window.location.reload();
        }, 10000);
      } else {
        setDeleteNodeMsg(response.message);
        setInActiveBtn(true);
      }
    } else {
      setDeleteNodeMsg('Error deleting node');
      if (spinnerDiv) {
        spinnerDiv.style.display = 'none';
      }
      setDeleteNode(false);
      setInActiveBtn(true);
    }
  };

  const clickedDeleteIcon = (nodeId: string | number) => {
    setNodeId(nodeId.toString());
    setModalShow(true);
    setDeleteNode(true);
  };

  const confirmDeleteNode = () => {
    deleteNode();
  };

  const showRpcMessage = () => {
    const div2 = document.getElementById('rpcFail2');
    if (div2) div2.style.display = 'block';
    setTimeout(() => {
      if (div2) div2.style.display = 'none';
    }, 1000);
  };

  const showAnalyticsMsg = () => {
    if (!analyticsUrls) {
      showMessage('analyticsDiv');
    }
  };

  const showMessage = (id:string) => {
    const div2 = document.getElementById(id);
    if (div2) div2.style.display = 'block';
    setTimeout(() => {
      if (div2) div2.style.display = 'none';
    }, 1000);
  };
  const checkNodeStatus = (state: string) => {
    if (state === 'requested' || state === 'failed' || state === 'stopped') {
      return false;
    }
    return true;
  };
  return (
    <div
      className="mt-4 d-flex text-center"
      style={{ textAlign: 'center', justifyContent: 'center' }}
    >
      <div className="col-4 p-1 mt-1 border-end">
        <img
          src={getCloudImage(cloudimage)}
          height="30px"
          width="30px"
          alt=""
        />
        <p className="node-font mt-1 mb-0" title={node.toString()}>
          {nodeName}
        </p>
      </div>
      <div className="col-4 p-2 border-end">
        {/* <p className="mb-0">{getRegionName(region)}</p> */}
        <a
          href="#display"
          className="btn mt-1"
          onClick={() => {
            setText(node, endpoint);
          }}
          style={{
            border: '#4D88F7 solid 2px',
            color: '#3E7EF5',
            fontSize: '12px',
          }}
        >
          View Endpoint
        </a>
      </div>
      {networkPayment && (
        <div className="mt-2 pt-3 col-6">
          <h6>Network Payment Pending</h6>
        </div>
      )}
      {!networkPayment && state === 'payment_pending' && (
        <div className="mt-2 pt-3 col-6">
          <a
            href={redirectionUrl}
            className="btn btn-primary text-decoration-none"
          >
            Pay Now
          </a>
        </div>
      )}
      {!networkPayment && state !== 'payment_pending' && (
        <div className="mt-3 p-1 col-4">
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <li
              className="btnNodeli"
              data-toggle="tooltip"
              data-placement="top"
              aria-hidden
              title="Show Analytics"
              onClick={showAnalyticsMsg}
            >
              <div className="dropdown show">
                <img
                  className="btnNode"
                  src={chart}
                  height="22px"
                  alt=""
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  data-bs-toggle={checkNodeStatus(state) ? 'dropdown' : ''}
                  aria-haspopup
                  aria-expanded
                  style={checkNodeStatus(state) ? { cursor: 'pointer' } : { cursor: 'not-allowed' }}
                />
                {analyticsUrls && (
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  {analyticsUrls.length > 0
                    ? analyticsUrls.map((item, index) => <a className="dropdown-item" href={item.dashboardURL} target="_blank" key={`analytics-${index.toString()}`} rel="noreferrer">{item.dashboardName}</a>) : null}
                </div>
                )}
              </div>
            </li>
            {state === 'ready' || state === 'provisioning' ? (
            <li
              className="btnNodeli"
              aria-hidden
              onClick={() => {
                clickedDeleteIcon(node);
              }}
            >
              <img
                className="btnNode mx-1"
                src={deleteicon}
                height="22px"
                alt=""
              />
            </li>
            ) : null}
            {state === 'ready' && (
              <img
                src={runningicon}
                style={{ height: '22px' }}
                title="Running"
                alt=""
              />
            )}
            {state === 'provisioning' && (
              <img
                src={pendingIcon}
                style={{ height: '22px' }}
                title="Pending"
                alt=""
              />
            )}
            {state !== 'ready' && state !== 'provisioning' && (
              <img
                src={infocircle}
                style={{ height: '22px' }}
                title="Stop"
                alt=""
              />
            )}
          </div>
        </div>
      )}
      {showLoader && <Loading />}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Are you sure you want to delete Node?"
        visibleFooter
        visibleFooterCloseButton
        visibleHeaderCloseIcon={false}
        visibleConfirmBtn={deleteNodeBtn}
        confirmBtnText="Yes"
        onConfirm={confirmDeleteNode}
        confirmBtnClassName=""
      >
        <p className="status text-center pt-3">{deleteNodeMsg}</p>
      </Modal>
    </div>
  );
};

export default LandingCard;
